import { render } from "./YearSelector.vue?vue&type=template&id=c8815b1a&scoped=true"
import script from "./YearSelector.vue?vue&type=script&lang=js"
export * from "./YearSelector.vue?vue&type=script&lang=js"

import "./YearSelector.vue?vue&type=style&index=0&id=c8815b1a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8815b1a"]])

export default __exports__